import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 800);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, y: 20, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.8 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="back-to-top"
          aria-label="Back to top"
          className="fixed bottom-6 right-6 z-40 w-12 h-12 flex items-center justify-center border-2 border-[#090909] bg-[#DFFF00] text-[#090909] font-display text-xl leading-none hover:bg-[#090909] hover:text-[#DFFF00] hover:border-[#DFFF00] transition-colors shadow-[3px_3px_0_#090909]"
        >
          ↑
        </motion.button>
      )}
    </AnimatePresence>
  );
}
